"use strict";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import classNames from "classnames";
import CarrierService from "../../services/carrier_service";
import generalFormatter from "../../formatters/general";
import { History } from "react-router";
import "../../formatters/carrier_invoice";
import CarrierName from "../carrier_name";
import "../../api/api";
import Account from "../../api/account";
import { Table } from "../ui/v3/table";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
import { StatusTag, StatusTagStyle, StatusTagSize } from "../ui/v3/status_tag";
function toStatusTagStyle(invoice) {
  switch (invoice.status) {
    case "Paid":
    case "Approved":
    case "Complete":
    case "Processed":
      return StatusTagStyle.Success;
    case "Received":
      return StatusTagStyle.Info;
    case "Incomplete":
    case "Waiting":
    case "Reply":
    case "Exception":
      return StatusTagStyle.Warning;
    case "Deleted":
    case "Ignored":
    case "Moved to TMS":
      return StatusTagStyle.Alert;
    default:
      return StatusTagStyle.Default;
  }
}
function isAbandoned(invoice) {
  return invoice.state === "abandoned";
}
var PreviousInvoiceInformation = React.createClass({
  mixins: [History],
  render: function() {
    if (this.props.v3ReskinEnabled) return this.renderV3Reskin();
    var ordered = _(this.invoices()).chain().sortBy((invoice) => {
      return CarrierService.getCarrierOrUnknown(invoice.carrier_id).name;
    }).reverse().sortBy("created_at").value();
    const statusLabel = Account.auditBillingEnabled() ? "Carrier Invoice Status" : "Status";
    return /* @__PURE__ */ React.createElement("div", { "data-component": "PreviousInvoiceInformation" }, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, this.headerForInvoices()), /* @__PURE__ */ React.createElement("table", { className: "load-detail__info-table load-detail__previous-invoices" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: "load-detail__info-table-header" }, /* @__PURE__ */ React.createElement("th", null, "Invoice #"), this.possibleFuelAdvanceHeader(), /* @__PURE__ */ React.createElement("th", null, "Total"), /* @__PURE__ */ React.createElement("th", null, "Carrier"), /* @__PURE__ */ React.createElement("th", null, "Process Date"), /* @__PURE__ */ React.createElement("th", null, statusLabel), /* @__PURE__ */ React.createElement("th", null, "\xA0"))), /* @__PURE__ */ React.createElement("tbody", null, _.map(ordered, this.showInvoice))));
  },
  renderV3Reskin: function() {
    var ordered = _(this.invoices()).chain().sortBy((invoice) => {
      return CarrierService.getCarrierOrUnknown(invoice.carrier_id).name;
    }).reverse().sortBy("created_at").value();
    const possibleFuelAdvanceCol = this.hasFuelAdvances() && {
      heading: "Fuel advance?",
      content: (invoice) => invoice.fuel_advance ? "Yes" : "No"
    };
    const columns = [
      {
        heading: "Invoice",
        content: (invoice) => invoice.number || invoice.source_invoice_number || "N/A"
      },
      possibleFuelAdvanceCol,
      {
        heading: "Total",
        content: (invoice) => generalFormatter.currency(
          invoice.amount_to_pay || invoice.source_invoice_amount
        )
      },
      {
        heading: "Carrier",
        content: (invoice) => /* @__PURE__ */ React.createElement(
          CarrierName,
          {
            carrierID: invoice.carrier_id,
            includeExternalVendorId: true
          }
        )
      },
      {
        heading: "Process date",
        content: (invoice) => generalFormatter.shortDate(invoice.created_at)
      },
      {
        heading: Account.auditBillingEnabled() ? "Invoice status" : "Status",
        content: (invoice) => /* @__PURE__ */ React.createElement(
          StatusTag,
          {
            content: invoice.status,
            style: toStatusTagStyle(invoice),
            size: StatusTagSize.Small
          }
        )
      },
      {
        heading: "",
        content: (invoice) => this.viewButtonV3Reskin(invoice)
      }
    ].filter(Boolean);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-s)"
        }
      },
      /* @__PURE__ */ React.createElement("h3", null, this.headerForInvoicesV3Reskin()),
      /* @__PURE__ */ React.createElement(Table, { columns, rows: ordered })
    );
  },
  invoices() {
    return this.props.carrierInvoices || this.props.factorInvoices;
  },
  showInvoice: function(invoice, index) {
    var classes = classNames({
      "load-detail__invoice-table-current-invoice": this.isCurrent(invoice),
      "load-detail__invoice-table-abandoned-invoice": isAbandoned(invoice)
    });
    return /* @__PURE__ */ React.createElement("tr", { className: classes, key: "invoice-" + index }, /* @__PURE__ */ React.createElement("td", null, invoice.number || invoice.source_invoice_number || "N/A"), this.possibleFuelAdvance(invoice), /* @__PURE__ */ React.createElement("td", null, generalFormatter.currency(
      invoice.amount_to_pay || invoice.source_invoice_amount
    )), /* @__PURE__ */ React.createElement("td", { className: "load-detail__invoice-table-carrier" }, /* @__PURE__ */ React.createElement(
      CarrierName,
      {
        carrierID: invoice.carrier_id,
        includeExternalVendorId: true
      }
    )), /* @__PURE__ */ React.createElement("td", null, generalFormatter.shortDate(invoice.created_at)), /* @__PURE__ */ React.createElement("td", null, invoice.status), /* @__PURE__ */ React.createElement("td", null, this.viewButton(invoice)));
  },
  possibleFuelAdvanceHeader() {
    if (this.hasFuelAdvances()) {
      return /* @__PURE__ */ React.createElement("th", null, "Fuel Advance?");
    }
  },
  possibleFuelAdvance(invoice) {
    if (this.hasFuelAdvances()) {
      return /* @__PURE__ */ React.createElement("td", null, invoice.fuel_advance ? "Yes" : "No");
    }
  },
  viewButton: function(invoice) {
    var buttonText = "View";
    var newLocation = this.linkForInvoice(invoice);
    var classes = "button--confirmation load-detail__invoice-table-button";
    if (this.isCurrent(invoice)) {
      buttonText = "Viewing";
      classes = classes + " button--disabled";
    }
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        href: newLocation.location + (newLocation.query ? "?" + $.param(newLocation.query) : ""),
        className: classes,
        disabled: this.isCurrent(invoice),
        onClick: (e) => {
          this.viewInvoice(e, invoice);
        }
      },
      buttonText
    );
  },
  viewButtonV3Reskin: function(invoice) {
    const buttonText = this.isCurrent(invoice) ? "Viewing" : "View";
    const newLocation = this.linkForInvoice(invoice);
    let href = newLocation.location + (newLocation.query ? "?" + $.param(newLocation.query) : "");
    let onClick = (e) => this.viewInvoice(e, invoice);
    let disabled;
    if (this.isCurrent(invoice)) {
      onClick = () => {
      };
      href = void 0;
      disabled = true;
    }
    return /* @__PURE__ */ React.createElement(
      Button,
      {
        size: ButtonSize.Medium,
        variant: ButtonVariant.Text,
        disabled,
        onClick,
        href
      },
      buttonText
    );
  },
  isCurrent: function(invoice) {
    return invoice.id === this.props.currentInvoice.id;
  },
  viewInvoice: function(e, invoice) {
    e.preventDefault();
    var newLocation = this.linkForInvoice(invoice);
    this.history.pushState(
      null,
      newLocation.location,
      newLocation.query || this.props.location.query
    );
  },
  hasFuelAdvances() {
    return this.isFactorInvoices();
  },
  isFactorInvoices() {
    return !!this.props.factorInvoices;
  },
  isCarrierInvoices() {
    return !!this.props.carrierInvoices;
  },
  linkForInvoice(invoice) {
    if (this.isCarrierInvoices()) {
      return {
        location: this.props.location.pathname.replace(
          /carrier_invoices\/(\d+)/,
          "carrier_invoices/" + invoice.id
        )
      };
    } else {
      const newParams = _.omit(this.props.location.query, "factorInvoiceId");
      const currentPath = this.props.location.pathname;
      var batchId = 0;
      const pMatch = currentPath.match(/index-document-batches\/(\d+)/);
      if (pMatch) {
        batchId = parseInt(pMatch[1]);
      }
      if (currentPath.match(/factor_invoices/)) {
        if (_.some(invoice.document_batch_ids, (id) => id == batchId)) {
          return {
            location: "/index-document-batches/" + batchId,
            query: _.extend(newParams, { factorInvoiceId: invoice.id })
          };
        } else {
          return {
            location: this.props.location.pathname.replace(
              /factor_invoices\/(\d+)/,
              "factor_invoices/" + invoice.id
            ),
            query: newParams
          };
        }
      }
      return {
        location: currentPath + "/factor_invoices/" + invoice.id,
        query: newParams
      };
    }
  },
  includesInvoiceNumber() {
    return this.isCarrierInvoices();
  },
  headerForInvoices() {
    if (this.isCarrierInvoices()) {
      return "Carrier Invoices";
    } else {
      return "Invoices";
    }
  },
  headerForInvoicesV3Reskin() {
    if (this.isCarrierInvoices()) {
      return "Carrier invoices";
    } else {
      return "Invoices";
    }
  }
});
export default PreviousInvoiceInformation;
